import React from "react";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import { useTranslation } from "@/lib/i18n";

/**
 * Reusable shell for the legal pages. Keeps spacing, typography and dark
 * aesthetic consistent. Content is a list of `{ heading, body }` sections.
 */
export default function LegalPage({ title, lastUpdated, intro, sections = [], testId }) {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col">
      <NavBar showSearch={false} />
      <main
        className="flex-1 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14"
        data-testid={testId || "legal-page"}
      >
        <div className="text-[11px] uppercase tracking-wider text-muted-foreground">{t("legal.kicker")}</div>
        <h1 className="mt-1 font-display text-3xl sm:text-4xl tracking-tight">{title}</h1>
        {lastUpdated ? (
          <div className="mt-1 text-xs text-muted-foreground tabular">{t("legal.last_updated", { date: lastUpdated })}</div>
        ) : null}
        {intro ? <p className="mt-4 text-sm leading-relaxed text-foreground/85">{intro}</p> : null}

        <div className="mt-8 space-y-8">
          {sections.map((s, idx) => (
            <section key={s.heading || idx}>
              {s.heading ? (
                <h2 className="font-display text-xl tracking-tight">{s.heading}</h2>
              ) : null}
              {Array.isArray(s.body) ? (
                <div className="mt-2 space-y-2 text-sm leading-relaxed text-foreground/85">
                  {s.body.map((p, i) => <p key={i}>{p}</p>)}
                </div>
              ) : (
                <p className="mt-2 text-sm leading-relaxed text-foreground/85">{s.body}</p>
              )}
            </section>
          ))}
        </div>

        <div className="mt-12 rounded-xl border border-border/70 bg-card/40 p-4 text-xs text-muted-foreground leading-relaxed">
          {t("legal.placeholder_note")}
        </div>
      </main>
      <Footer />
    </div>
  );
}
